import React from 'react';
import PropTypes from 'prop-types';
import { useTheme, buildUseStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import ErrorIcon from 'Components/ComponentLibrary/Components/Uncategorized/Icons/ErrorIcon';
import { Tooltip } from 'Components/UI/Tooltip';
import fr from 'facet-rest';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';

const useStyles = buildUseStyles('PaymentFailedAlert', () => ({
  root: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const PaymentFailedAlert = ({
  className,
  resource,
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  // If payment hasn't failed, show nothing
  if (!resource.isTruthy('paymentFailed')) {
    return null;
  }

  return (
    <Tooltip placement={'top'} title={resource.attr('paymentFailedDetails')}>
      <Box className={classes.root}>
        <ErrorIcon className={className} />
      </Box>
    </Tooltip>
  );
};

PaymentFailedAlert.defaultProps = {
  className: '',
};

PaymentFailedAlert.propTypes = {
  className: PropTypes.string,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default PaymentFailedAlert;
